var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "blockWrapper",
      class: [
        "buttons-bottom-header__item favorites-header _with-popup",
        { "_with-popup--active": _vm.isPopupShow },
      ],
      attrs: { "data-list-type": "jsFavoriteList" },
    },
    [
      _c(
        "a",
        {
          staticClass: "buttons-bottom-header__link",
          attrs: { href: "/favorites/" },
        },
        [
          _c("div", { staticClass: "buttons-bottom-header__icon" }, [
            _c(
              "svg",
              {
                attrs: {
                  width: "22",
                  height: "21",
                  viewBox: "0 0 22 21",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg",
                },
              },
              [
                _c("path", {
                  attrs: {
                    d: "M11.4084 1.80165L14.142 7.58318L20.4409 8.12043C20.8778 8.15789 20.7726 8.33698 20.4409 8.62187L15.9461 13.0936L17.3779 19.2074C17.4771 19.6322 17.4222 19.7257 17.0469 19.5L11.2249 16.4995L5.54688 19.5C5.17057 19.7248 4.9726 19.6313 5.07189 19.2074L6.50365 13.0936L2.0367 8.62187C1.70507 8.33698 1.56994 8.1569 2.00781 8.11944L8.30675 7.5822L11.0005 1.80165C11.1713 1.39945 11.2376 1.39945 11.4084 1.80165Z",
                    stroke: "#474747",
                    "stroke-width": "2",
                  },
                }),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "items-count", staticStyle: { display: "none" } },
              [_vm._v("1")]
            ),
            _vm._v(" "),
            _vm.countItems > 0
              ? _c(
                  "div",
                  {
                    staticClass:
                      "buttons-bottom-header__icon-count items-count__show",
                  },
                  [_vm._v("\n        " + _vm._s(_vm.countItems) + "\n      ")]
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("span", [_vm._v("Избранное")]),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "buttons-bottom-header__item-popup" }, [
        _c(
          "div",
          {
            staticClass: "buttons-bottom-header__added-products jsFavoriteList",
          },
          [
            _vm._l(_vm.items, function (item, key) {
              return [
                _c("header-product", {
                  key: "header-favorite-product-" + key,
                  attrs: { item: item },
                  on: { deleteItem: _vm.deleteItem },
                }),
              ]
            }),
          ],
          2
        ),
        _vm._v(" "),
        _vm._m(0),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "buttons-bottom-header__btn-wrapper" }, [
      _c(
        "a",
        {
          staticClass: "buttons-bottom-header__btn _btn",
          attrs: { href: "/favorites/" },
        },
        [_c("p", [_vm._v("В избранное")]), _vm._v(" "), _c("span")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }